import { AbilityContext } from "@context/can";
import { UserContext } from "../context/user";
import { setItemToStore } from "@helpers/utils";
import size from "lodash/size";
import { useContext } from "react";
import { ROLE_ABILITY } from "../ability/common";

const usePanelAbility = () => {
  const ability = useContext(AbilityContext);
  const { userData = {}, handleUserData } = useContext(UserContext);
  /**
   * It takes a response object and updates the ability object based on the type of organization
   * @param response - The response from the server.
   */
  const handlePanelAbility = ({ userInfo = {} }) => {
    const { user = {}, token = "" } = size(userInfo) ? userInfo : userData;
    const tempUser = size(userInfo) ? userInfo : userData;
    let modifiedAbility = [];

    if (size(user)) {
      const role = user.role;
      modifiedAbility = modifiedAbility.concat(ROLE_ABILITY[role] || []);

      setItemToStore("userInfo", tempUser);
      handleUserData(tempUser);
      /** I changed lang here */
      setItemToStore("lang", user.lang || "en");
      if (token) setItemToStore("token", token);
    }

    setItemToStore("isLogoutRequired", false);

    ability.update(modifiedAbility);
    // setTempAbility([...modifiedAbility]);
    setItemToStore("ability", modifiedAbility);
    window.dispatchEvent(new Event("ability"));
  };

  return {
    handlePanelAbility
  };
};
export default usePanelAbility;
